<template>
  <div class="index_demo">
    <div class="top">
      <div class="bgc">
        <el-carousel 
            :autoplay="true" 
            trigger="click"
            :interval="3000"
            arrow="never">
            <el-carousel-item v-for="(item, idx) in bannerList" :key="idx">
              <img :src="item.fileUrls" alt="" @click="clickBanner(item)">
            </el-carousel-item>
        </el-carousel>
      </div>
      <div class="top_model d-f f-ai-c f-jc-c">
        <div v-for="item in menuList" :key="item.key" :class="['five_box','d-f','f-ai-c','f-jc-c', 'c-p', item.className]" @click="handleSelect(item.key)">
          <div class="five_icon d-f f-jc-c">
            <img :src="item.imgUrl" alt="">
          </div>
          <div class="five_desc">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div>
        <div class="ct_title">
          <div class="ct_desc d-f f-jc-c">上课瞬间</div>
          <div class="ct_line d-f f-ai-c">
            <div class="long_line"></div>
            <div class="short_line"></div>
          </div>
        </div>
        <div class="ct_substance">
          <!-- 叠加滚动栏 -->
          <!-- <fiveSwiper/> -->
          <el-carousel
            ref="nop"
            :autoplay="false"
            arrow="never" 
            indicator-position="none" 
            type="card" 
            height="552px">
              <el-carousel-item v-for="(item, idx) in substanceList" :key="idx">
                <img :src="item.fileUrls" alt="">
              </el-carousel-item>
          </el-carousel>
          <div class="chang_icon chang_icon_left d-f f-ai-c f-jc-c c-p" :class="substanceList.length <= 1 ?'chang_icon_disable':''" @click="substanceList.length > 1 ? prev() :''">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="chang_icon chang_icon_right d-f f-ai-c f-jc-c c-p" :class="substanceList.length <= 1 ?'chang_icon_disable':''" @click="substanceList.length > 1 ? next() :''">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="excellent_recommendation mg-t-70">
        <div class="ct_title">
          <div class="ct_desc d-f f-jc-c">精彩推荐</div>
          <div class="ct_line d-f f-ai-c">
            <div class="long_line long_green"></div>
            <div class="short_line short_green"></div>
          </div>
        </div>
        <div class="ct_carousel">
          <el-carousel 
            indicator-position="outside" 
            :autoplay="false" 
            trigger="click"
            arrow="never">
            <el-carousel-item>
              <div class="recommend d-f f-ai-c f-jc-sb">
                <div class="re_box"
                  v-for="(item, idx) in dreamList" 
                  :key="idx">
                  <img :src="item.coverFileFileUrls" alt="">
                  <div class="re_desc overflow-1">{{item.title}}</div>
                  <div @click="jumpToDetails(item)" :class="['c-p re_btn', idx == 0 ? 're_btn' : idx == 1 ?'re_btn_green':'re_btn_blue']">MORE+</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="excellent_recommendation_img">
          <img src="@/assets/images/index/bgc2.png" alt="">
        </div>
      </div>

      <div class="recent_news mg-t-70">
        <div class="ct_title ct_special">
          <div class="ct_desc d-f f-jc-c">最新动态</div>
          <div class="ct_line d-f f-ai-c">
            <div class="long_line long_blue"></div>
            <div class="short_line short_blue"></div>
          </div>
          <div class="ct_more d-f f-ai-c f-jc-c c-p" @click="jumpToList()">MORE</div>
        </div>
        <div class="re_dynamic d-f f-ai-c f-jc-sb">
          <div class="re_dynamic_tb">
            <div class="re_dynamic_tb_bgc c-p" @click="jumpToList('公告')">
              <img src="@/assets/images/index/icon9.png" alt="">
            </div>
            <ul class="mg-t-15">
              <li v-for="(item, idx) in tableList1" :key="idx" class="c-p" @click="jumpToDetails(item)">
                <p class="d-f f-ai-c f-jc-sb">
                  <span class="re_dynamic_desc">{{item.title}}</span>
                  <span class="re_dynamic_date">{{item.createTime ? item.createTime.split(' ')[0] : ''}}</span>
                </p>
              </li>
            </ul>
          </div>
          <div class="re_dynamic_tb">
            <div class="re_dynamic_tb_bgc c-p" @click="jumpToList('资讯')">
              <img src="@/assets/images/index/icon8.png" alt="">
            </div>
            <ul class="mg-t-15">
              <li v-for="(item, idx) in tableList2" :key="idx" class="c-p" @click="jumpToDetails(item)">
                <p class="d-f f-ai-c f-jc-sb">
                  <span class="re_dynamic_desc">{{item.title}}</span>
                  <span class="re_dynamic_date">{{item.createTime ? item.createTime.split(' ')[0] : ''}}</span>
                </p>
              </li>
            </ul>
          </div>
          <div class="re_dynamic_tb">
            <div class="re_dynamic_tb_bgc c-p" @click="jumpToList('赛事')">
              <img src="@/assets/images/index/icon6.png" alt="">
            </div>
            <ul class="mg-t-15">
              <li v-for="(item, idx) in tableList3" :key="idx" class="c-p" @click="jumpToDetails(item)">
                <p class="d-f f-ai-c f-jc-sb">
                  <span class="re_dynamic_desc">{{item.title}}</span>
                  <span class="re_dynamic_date">{{item.createTime ? item.createTime.split(' ')[0] : ''}}</span>
                </p>
              </li>
            </ul>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import fiveSwiper from '@/components/Index/fiveSwiper'
import { GetAdvertisingPages, GetClassMoment, GetArticleRecommend, GetLastDynamic } from '@/utils/commonApi'
export default {
  components: {
    fiveSwiper
  },
  data() {
    return {
      menuList: [
        { name: '关于我们', key: '2', imgUrl:require('@/assets/images/index/icon11.png'), className: 'color2' },
        { name: '软件下载', key: '3', imgUrl:require('@/assets/images/index/icon10.png'), className: 'color3' },
        { name: '爱宝商城', key: '4', imgUrl:require('@/assets/images/index/icon7.png'), className: 'color4' },
        { name: '教学平台', key: '5', imgUrl:require('@/assets/images/index/icon4.png'), className: 'color5' },
        { name: '合作加盟', key: '6', imgUrl:require('@/assets/images/index/icon5.png'), className: 'color6' },
      ],
      // 轮播图
      bannerList: [],
      // 上课瞬间
      substanceList: [],
      // 精彩推荐
      dreamList: [],
      // 最新动态
      tableList1: [],
      tableList2: [],
      tableList3: [],
    }
  },
  mounted() {
    this.GetAdvertisingPages()
    this.GetClassMoment()
    this.GetArticleRecommend()
    this.GetLastDynamic()
  },
  methods: {
    // banner图
    GetAdvertisingPages() {
      let params = {
        AdvertisingType: 0,
        PageSize: 3,
        PageIndex: 1
      }
      GetAdvertisingPages(params).then(res => {
        // console.log('res', res);
        if(res.code === "OK") {
          this.bannerList = res.content.data
        }
      })
    },
    clickBanner(item) {
      if(item.linkHerf) {
        window.open(item.linkHerf)
      }
    },

    // 前台获取上课瞬间
    GetClassMoment() {
      let params = {
        PageSize: 5,
        PageIndex: 1,
      }
      GetClassMoment(params).then(res => {
        if(res.code === "OK") {
          this.substanceList = res.content.data
        }
      })
    },
    // 后退
    prev () {
      this.$refs.nop.prev();
    },
    // 前进
    next () {
      this.$refs.nop.next();
    },

    // 前台获取获取文章精彩推荐
    GetArticleRecommend() {
      let params = {
        PageSize: 3,
        PageIndex: 1,
      }
      GetArticleRecommend(params).then(res => {
        if(res.code === "OK") {
          this.dreamList = res.content.data
        }
      })
    },
    // 精彩推荐点击
    dreamClick(item) {
      console.log(111, item);
    },

    // 获取最新动态
    GetLastDynamic() {
      let params = {
        PageSize: 3,
        PageIndex: 1,
      }
      GetLastDynamic(params).then(res => {
        if(res.code === "OK") {
          this.tableList1 = res.content['公告']
          this.tableList2 = res.content['资讯']
          this.tableList3 = res.content['赛事']
        }
      })
    },

    jumpToDetails(item) {
      // this.$router.push({path: '/index_details', query: { articleId: item.articleId, createTime:item.createTime, title: item.title}})
      this.$router.push({path: '/index_details', query: { articleId: item.articleId, path: '/index' }})
    },

    handleSelect(value) {
      this.$emit('getHandleSelect', value)
    },

    jumpToList(value) {
      this.$router.push({path: '/index_list', query: { name: value }})
    },
  }
};
</script>

<style scoped lang="less">
.index_demo, .top, .bgc, .content{
  width: 100%; 
  height: 100%;
}

/* 顶部 */
.top {
  height: 38.5417vw;
  position: relative;
  .bgc {
    z-index: 1;
    /deep/.el-carousel__container {
      height: 38.5417vw !important;
      width: 100vw;
    }
    /deep/.el-carousel__indicators {
      position: absolute;
      bottom: 8.8542vw;
      width: 58vw;
      text-align: right;
    }
    img {
      width: 100vw;
      height: 38.5417vw;
      background-size: 100% 100%;
      display: block;
    }
  }
}

.top_model {
  position: absolute;
  bottom: -7.2917vw;
  left: 0;
  right: 0;
  z-index: 99;
  .five_box {
    width: 11.9792vw;
    height: 11.9792vw;
    border-radius: 50%;
    margin-right: 1.0417vw;
    flex-flow: column;
    box-shadow: 0vw 0vw 0.5208vw 0 rgba(0, 0, 0, 0.3);
    background: #fff;
  }
  .five_icon {
    width: 100%;
  }
  .five_icon img {
    height: 3.3333vw;
    width: 3.3333vw;
    margin-bottom: 0.5208vw;
  }
  .five_desc {
    font-size: 1.5625vw;
    color: #fff;
    font-weight: 700;
  }
}
.color2{
  background-image: linear-gradient(to right, rgb(243, 153, 36) , rgb(251, 202, 116)) !important;
}
.color3{
  background-image: linear-gradient(to right, rgb(161, 189, 22) , rgb(203, 225, 98)) !important;
}
.color4{
  background-image: linear-gradient(to right, rgb(53, 151, 211) , rgb(112, 196, 238)) !important;
}
.color5{
  background-image: linear-gradient(to right, rgb(75, 171, 191) , rgb(125, 224, 237)) !important;
}
.color6{
  background-image: linear-gradient(to right, rgb(211, 94, 164) , rgb(238, 134, 197)) !important;
}

::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 0.7813vw;
  height: 0.7813vw;
  background: transparent;
  border: 0.1563vw solid #ffffff;
  border-radius: 50%;
  opacity: 0.4;
  margin-right: 0.7813vw;
}  
::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button{
  width: 0.7813vw;
  height: 0.7813vw;
  background: rgb(195, 219, 73);
  border-radius: 50%;
  opacity: 1;
}
::v-deep.el-carousel__indicators--outside button {
  background-color: #fff !important;
}

/* 中间内容 */
.content {
  height: 108.0208vw;
  padding-top: 11.9792vw;
  box-sizing: border-box;
  background-image: url('@/assets/images/index/bgc1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;

  .excellent_recommendation {
    padding-bottom: 1.0417vw;
    position: relative;
    /deep/.el-carousel__indicators {
      height: 3.125vw;
      line-height: 3.125vw;
    }
    .excellent_recommendation_img {
      width: 100vw;
      height: 17.7083vw;
      position: absolute;
      top: 14.5833vw;
      left: 0;
      right: 0;
      z-index: -1;
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .ct_title {
    position: relative;
    width: 11.7188vw;
    height: 2.0833vw;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 2.6042vw;

    .ct_desc{
      font-size: 1.6667vw;
      letter-spacing: 0.2083vw;
      position: absolute;
      width: 11.7188vw;
      top: 0;
      z-index: 19;
    }
    .ct_line {
      position: absolute;
      bottom: 0vw;
      z-index: 1;
    }
    .ct_more {
      width: 3.125vw;
      height: 1.3542vw;
      border-radius: 0.6771vw;
      border: 0.0521vw solid #666;
      color: #666;
      font-size: 0.7292vw;
      position: absolute;
      bottom: 0.3125vw;
      z-index: 1;
      right: 0;
    }
    .long_line {
      width: 10.4167vw;
      height: 0.7813vw;
      background-image: linear-gradient(to right, rgb(240, 132, 1), rgb(254, 187, 32)) !important;
      border-radius: 0.7813vw;
      margin-right: 0.2604vw;
    }
    .short_line {
      width: 0.7813vw;
      height: 0.7813vw;
      background: rgb(254, 187, 32) !important;
      border-radius: 50%;
    }
    .long_green {
      background-image: linear-gradient(to right, rgb(171, 205, 2), rgb(213, 231, 125)) !important;
    }
    .short_green {
      background: rgb(213, 231, 125) !important;
    }
    .long_blue {
      background-image: linear-gradient(to right, rgb(0, 160, 233), rgb(128, 208, 243)) !important;
    }
    .short_blue {
      background: rgb(128, 208, 243) !important;
    }
  }
  .ct_special {
    width: 64.5833vw;
  }
  .el-carousel__item {
    // background: hotpink;
    display: block;
  }
  // 精彩推荐
  .ct_carousel {
    width: 64.5833vw;
    margin: 0 auto;
    /deep/.el-carousel__container {
      height: 22.3958vw !important; 
    }
    .recommend {
      height: 100%;
      width: 100%;
      .re_box {
        height: 22.6042vw;
        width: 20.8333vw;
        // padding: 0.5208vw;
        background: #fff;
        border-radius: 0.5208vw;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 15.625vw;
        }
        .re_desc {
          width: 95%;
          text-align: center;
          font-size: 0.9375vw;
          // font-weight: bold;
          height: 3.75vw;
          line-height: 3.75vw;
          margin: 0 auto;
        }
        .re_btn {
          width: 8.75vw;
          height: 2.2917vw;
          line-height: 2.2917vw;
          text-align: center;
          margin: 0 auto;
          background-image: linear-gradient(to bottom, rgb(254, 187, 32), rgb(240, 132, 1)) !important;
          border-radius: 1.1458vw;
          color: #fff;
          font-size: 0.8333vw;
        }
        .re_btn_green{
          background-image: linear-gradient(to bottom, rgb(213, 231, 125), rgb(171, 205, 2)) !important;
        }
        .re_btn_blue{
          background-image: linear-gradient(to bottom, rgb(128, 208, 243), rgb(0, 160, 233)) !important;
        }
      }
    }
  }
  // 最新动态
  .recent_news {
    padding-bottom: 3.6458vw;
  }
  .re_dynamic {
    width: 64.5833vw;
    margin: 0 auto;

    .re_dynamic_tb {
      width: 20.8333vw;
      box-sizing: border-box;
      .re_dynamic_tb_bgc {
        width: 20.8333vw;
        height: 7.6042vw;
        img {
          height: 100%;
          width: 100%;
          border-radius: 0.5208vw;
        }
      }
      ul {
        list-style-type: circle;
        margin-left: 1.0417vw;
        font-size: 0.7292vw;
        height: 6.7708vw;
        li {
          height: 1.3542vw;
          line-height: 1.3542vw;
          .re_dynamic_desc {
            width: 9.375vw;
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #222;
          }
          .re_dynamic_date {
            font-size: 0.625vw;
            color: #444;
          }
        }
      }
    }
  }
}

/deep/.ct_substance {
  width: 75.4167vw;
  margin: 0 auto;
  position: relative;
  .el-carousel__item {
    width: 38.3333vw !important;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .chang_icon_left {
    position: absolute;
    left: 0;
    top: calc(50% - 1.6667vw);
    z-index: 199;
  }
  .chang_icon_right {
    position: absolute;
    right: 0;
    top: calc(50% - 1.6667vw);
    z-index: 199;
  }
  .chang_icon {
    width: 3.3333vw;
    height: 3.3333vw;
    background: rgb(195, 219, 73);
    border-radius: 50%;
    color: #fff;
  }
  .chang_icon i {
    font-size: 1.6667vw;
  }
  .chang_icon_disable {
    background: rgb(223, 223, 223);
  }
}


</style>